<template>
	<symbol :id="`${prefix}add`" viewBox="0 0 34 34">
		<circle
			fill="none"
			:stroke="getColor('main')"
			:stroke-width="strokeWidth"
			cx="17"
			cy="17"
			r="16"
		/>
		<line
			fill="none"
			:stroke="getColor('main')"
			:stroke-width="strokeWidth"
			x1="17"
			y1="11"
			x2="17"
			y2="23"
		/>
		<line
			fill="none"
			:stroke="getColor('main')"
			:stroke-width="strokeWidth"
			x1="23"
			y1="17"
			x2="11"
			y2="17"
		/>
	</symbol>
</template>

<script>
export default {
	name: 'NiIconAdd',


	props: {
		icon: {
			type: String,
		},

		prefix: {
			type: String,
			required: true,
		},

		state: {
			type: [String, Number],
			required: false,
		},

		palette: {
			type: Object,
		},

		disabled: {
			type: Boolean,
			default: false,
		},

		params: {
			type: Object,
			required: false,
		},
	},


	computed: {
		colors() {
			return {
				main: this.$palette.main_color,
				main__disabled: this.$palette.disabled_color,

				...this.palette,
			};
		},

		strokeWidth() {
			if (this.params && this.params.strokeWidth) {
				return this.params.strokeWidth;
			}
			return 2;
		},
	},


	methods: {
		getColor(color) {
			let bits = [
				color,
			];

			if (this.disabled) {
				bits.push('disabled');
			}

			return this.colors[bits.join('__')];
		},
	},
};
</script>
